export default "__VITE_ASSET__DmcY9R$U__"